<script setup lang="ts">
import { computed } from 'vue'

import { usePageStore } from '../../../../stores/page'
import { useImgSrcSet } from '../../../../composables/use-img-src-set'

import type { ImageObject } from '../../../../composables/use-img-src-set'

type EpgChannel = {
  originId?: number,
  name?: string,
  url?: string,
  logo?: ImageObject | null
}

const props = defineProps<{
  channel?: EpgChannel,
  inHeader?: boolean
}>()

const { createImgSrc } = useImgSrcSet()
const pageStore = usePageStore()

const channelLogoUrl = computed(() => props.channel?.logo
  ? createImgSrc({
    image: props.channel.logo,
    brand: pageStore.brandFromStore,
    type: 'webp',
    setName: 'channelLogo'
  })
  : null)
</script>

<template>
  <a :href="channel?.url"
     :class="[
       'bx-epg-channel',
       { 'bx-epg-channel--detail': inHeader } ]">
    <figure v-if="channelLogoUrl">
      <img :src="channelLogoUrl"
           :alt="channel?.logo?.imageAltText"
           :title="channel?.logo?.imageAltText"
           :width="channel?.logo?.width"
           :height="channel?.logo?.height"
           loading="lazy">
    </figure>
    <span>{{ channel?.name }}</span>
  </a>
</template>
